import { Link } from "react-router";
import CustomAvatar from "./CustomAvatar";
import { ILeader } from "@/lib/community";
import { Crown, Trophy, Medal } from "lucide-react";
import { MixpanelActions } from "../../integrations/mixpanel/mixpanel";

const topStyles = [
  {
    icon: <Crown className="text-yellow-400 w-5 h-5" />,
    ring: "ring-1 ring-yellow-200 bg-yellow-50 dark:ring-yellow-600 dark:bg-yellow-900/20",
    text: "text-yellow-700 dark:text-yellow-300",
  },
  {
    icon: <Trophy className="text-gray-400 w-5 h-5" />,
    ring: "ring-1 ring-gray-200 bg-gray-50 dark:ring-gray-600 dark:bg-gray-800/50",
    text: "text-gray-600 dark:text-gray-300",
  },
  {
    icon: <Medal className="text-red-800 w-5 h-5 dark:text-red-400" />,
    ring: "ring-1 ring-red-100 bg-red-50 dark:ring-red-600 dark:bg-red-900/20",
    text: "text-red-800 dark:text-red-300",
  },
];

export function LeaderRow({
  user,
  index,
  total,
}: {
  user: ILeader;
  index: number;
  total: boolean;
}) {
  return (
    <Link
      to={`/user/${user.user_id}`}
      onClick={() => MixpanelActions.clickUserProfile()}
    >
      <li
        className={`flex items-center gap-2 py-1.5 px-2 rounded-lg transition group
          ${
            index < 3
              ? `${topStyles[index].ring} ${topStyles[index].text} shadow-sm`
              : "hover:bg-blue-50"
          }`}
        style={{
          marginTop: index === 0 ? 0 : "0.35rem",
          minHeight: "40px",
        }}
      >
        <span className="flex items-center justify-center w-6 h-6 min-w-[22px]">
          {index < 3 ? (
            topStyles[index].icon
          ) : (
            <span className="font-semibold text-gray-400 text-sm">
              {index + 1}
            </span>
          )}
        </span>
        <div className="flex items-center gap-2">
          <CustomAvatar
            userData={{
              username: user.username,
              avatar: user.avatar,
              user_rating: { score: user.total_score || user.score },
            }}
            size="sm"
            className="w-7 h-7"
          />
          <div className="flex-1 min-w-0">
            <div
              className={`font-medium text-sm truncate ${
                index < 3
                  ? topStyles[index].text
                  : "text-gray-900 dark:text-gray-400"
              }`}
            >
              {user.username}
            </div>
          </div>
        </div>
        <span
          className={`ml-auto font-bold text-sm ${
            index < 3 ? topStyles[index].text : "text-gray-500"
          }`}
        >
          {!total ? "+" : ""}
          {user.score}
        </span>
      </li>
    </Link>
  );
}
